module.exports = __webpack_public_path__ + "static/media/logo_vertical_300x300.ce65eca8.png";